module.exports = __webpack_public_path__ + "img/narikyo.258b56ea.png";